<template>
  <div>
    <!-- WHen user not subscribe -->
    <div
      v-if="
        !group.is_participant && !group.is_admin && !$vuetify.breakpoint.xsOnly
      "
    >
      <!-- ($vuetify.breakpoint.xsOnly && tradeList.length != 0) -->
      <div class="d-flex align-center">
        <div
          class="main-label"
          :class="$vuetify.breakpoint.xsOnly ? 'ml-0' : 'ml-3'"
        >
          Featured Trades
        </div>
        <v-tooltip
          content-class="tooltip"
          color="#F7FAFF"
          bottom
          max-width="410"
        >
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              <v-icon
                :small="$vuetify.breakpoint.xsOnly"
                class="ml-1"
                v-bind="attrs"
                v-on="on"
              >
                mdi-information-outline
              </v-icon>
            </div>
          </template>
          <span class="tooltip-text">
            Posted trade idea along with gain/loss/return/accuracy and other
            metrics is solely intended for transparency, understanding,
            illustration, awareness, education and to enable the users to take
            informed decision. This transparency allows the investor to evaluate
            the effectiveness of the recommendations. Fluctuations in the price
            depend upon the market scenario, you may or may not be able to
            transact at the recommended price. Investor should understand that
            his/her investment decision is based on personal investment needs
            and risk tolerance. Past performance does not guarantee any future
            returns. Investments in the securities market are subject to market
            risks. Read all the related documents carefully before investing.
          </span>
        </v-tooltip>
      </div>
      <v-card-text>
        <v-row v-if="tradeList.length" class="mt-0 mb-12 pb-10">
          <v-col
            cols="12"
            sm="12"
            class="py-2"
            v-for="(trade, id) in tradeList"
            :key="id.trade"
          >
            <div class="position-relative">
              <NewTradeCard
                class="mb-4 blurred"
                :trade_data="trade"
                :ref="`${trade.id}`"
                v-if="trade.is_equity_trade"
              >
              </NewTradeCard>
              <!-- Lock the card for unsubscribe user -->
              <!-- <v-card
                class="overlay-card d-flex flex-column justify-center align-center"
              >
                <v-card-text>
                  <div class="d-flex justify-center align-center mt-6">
                    <div>
                      <img :src="lock" />
                    </div>
                    <h2>
                      This trade is locked, Unlock to have a <br />
                      look
                    </h2>
                  </div>
                  <div class="banking_div mx-auto my-4">
                    <div class="text-center mt-4 black--text">
                      <h2>{{ trade.security_industry }}</h2>
                    </div>

                    <div
                      class="d-flex justify-center align-center my-4 equal-widths"
                    >
                      <div class="text-center">
                        <div>Posted On</div>
                        <div class="black--text">
                          {{ formatTradeDate(trade.created) }}
                        </div>
                      </div>
                      <v-divider vertical class="mx-3"></v-divider>
                      <div class="text-center">
                        <div>Duration</div>
                        <div class="black--text">{{ trade.duration_name }}</div>
                      </div>
                      <v-divider vertical class="mx-3"></v-divider>
                      <div class="text-center">
                        <div>Profit Potential</div>
                        <div class="green--text">{{ trade.pl_percent }}%</div>
                      </div>
                    </div>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <div class="text-center">
                    <v-btn
                      color="primary text-none"
                      style="cursor: pointer"
                      @click="create_payment_order()"
                      >Unlock</v-btn
                    >
                  </div>
                </v-card-actions>
              </v-card> -->

              <FOTradecard
                :trade_data="trade"
                :ref="`${trade.id}`"
                class="my-4"
              >
              </FOTradecard>
            </div>
          </v-col>
        </v-row>
        <div v-else class="no-trades">
          <v-skeleton-loader width="750" type="card"></v-skeleton-loader>
        </div>
        <!-- <div class="no-trades" v-if="tradeList.length ===  0 ">
          There are no trades 
        </div> -->
      </v-card-text>
    </div>
    <!-- When user subscribe -->
    <div
      v-else-if="
        !$vuetify.breakpoint.xsOnly || group.is_participant || group.is_admin
      "
    >
      <!-- Main two tabs -->
      <!-- {{ all_trades }} {{ tab }} -->
      <!-- {{ tab }} {{ tab_items }} feature Trades {{ featureTradeList.length }} -->
      <v-tabs hide-slider grow v-model="tab" color="primary">
        <!-- <v-tab
          v-for="item in tab_items"
          :key="item.id"
          class="mytab"
          active-class="tab-color"
          :value="item"
          :itemid="item"
        >
          <div class="text-capitalize">
            {{ item }}
          </div>
        </v-tab> -->
        <!-- $vuetify.breakpoint.xsOnly -->
        <v-tab
          v-if="featureTradeList.length != 0 || group.is_admin"
          class="mytab"
          active-class="tab-color"
        >
          <div class="text-capitalize tabs-txt">Featured Trades</div>
        </v-tab>
        <v-tab
          value="all"
          class="mytab"
          :active-class="
            featureTradeList.length != 0 ||
            group.is_admin ||
            $vuetify.breakpoint.xsOnly
              ? 'tab-color'
              : 'single-tab'
          "
        >
          <div
            :class="
              featureTradeList.length != 0 ||
              group.is_admin ||
              $vuetify.breakpoint.xsOnly
                ? ' text-capitalize'
                : ' text-capitalize black--text'
            "
            class="tabs-txt"
          >
            All Trades
          </div>
        </v-tab>
        <v-tab
          v-if="$vuetify.breakpoint.xsOnly"
          class="mytab"
          active-class="tab-color"
        >
          <div class="text-capitalize tabs-txt">Watchlist</div>
        </v-tab>
      </v-tabs>
      <div
        v-if="
          tab_items[tab] == 'Featured Trades' &&
          tradeList.length != 0 &&
          group.is_admin
        "
        class="d-flex justify-end mt-4"
      >
        <v-btn @click="addTrade()" class="add-trade" color="primary">
          Add Trade
        </v-btn>
      </div>
      <!-- Main two tabs items -->
      <v-tabs-items class="bg-group" v-model="tab">
        <!-- Featured tab -->
        <v-tab-item
          v-if="featureTradeList.length != 0 || group.is_admin"
          class="bg-group"
        >
          <v-card-text
            :class="tab_items[tab] == 'Featured Trades' ? 'pt-0' : ''"
          >
            <v-row
              v-if="featureTradeList.length && filterType == 'featured'"
              class="mt-6 mb-12 pb-10"
            >
              <v-col
                cols="12"
                sm="12"
                class="py-2 pt-0"
                v-for="trade in featureTradeList"
                :key="trade.id"
              >
                <NewTradeCard
                  class="mb-4"
                  v-if="trade.is_equity_trade"
                  :trade_data="trade"
                  :ref="`${trade.id}`"
                >
                </NewTradeCard>
                <FOTradecard
                  v-else
                  :trade_data="trade"
                  :ref="`${trade.id}`"
                  class="my-4"
                >
                </FOTradecard>
              </v-col>
            </v-row>
            <div v-else-if="group.is_admin" class="no-feature-trades">
              <div>
                <v-img
                  class="gif-img"
                  height="80px"
                  width="80px"
                  :src="favourite"
                ></v-img>
                <!-- src="https://s3-alpha-sig.figma.com/img/0eb8/d6e0/79d4ded0ad24a30f2e3393358e7031fb?Expires=1716768000&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=OJkeCH~tjKyjyjV5niv09Q2CARsdR~3D7sNbxWrUika8-McksLxA7XtvlnwBrt4U~rqqi9ZTZShlPjxXRqRAPKHR8zICTshMTlALcU8UMGBGIwXDN3iwhdEgwwEgy~LeXyWK4awsRsi4nPWOuJHx4gHNors1mT3Ic~GB1thBYGM3u-xrXEDp9FU4ykxtWMElgin50r~Kew0Kq6MC4LgVMutB9syMBWJMz0kEgbzG1FIAWdwxdbrz36~FKUTmmZz~eYyKdxMrFILOnDB1aPZb2tb3kGp~w57Z5eT5QNYootwQp4HkM3rfJJclnAAdmsfmyXphrr-56zujHnoFGZuHqg__" -->
              </div>
              <div class="feature-txt my-3">Feature up to 10 trades</div>
              <div class="feature-sub-txt my-3 mt-1">
                Featured trades will be visible to non-members as well
              </div>
              <div v-if="!$vuetify.breakpoint.xsOnly">
                <v-btn @click="addTrade()" class="add-trade" color="primary">
                  Add Trade
                </v-btn>
              </div>
            </div>
          </v-card-text>
        </v-tab-item>
        <!-- All Trades -->
        <v-tab-item class="bg-group">
          <!-- All trades tabs -->
          <!-- {{ filterType }} || {{ all_trades_tab }}
          <div>{{ tab_items[tab] }}</div> -->
          <!-- {{ tab_items[tab] }} -->
          <v-tabs
            class="bg-group"
            :show-arrows="false"
            fixed-tabs
            v-model="all_trades_tab"
            color="primary"
          >
            <v-tab
              class="bg-group"
              v-for="(item, id) in all_trade_tabs_item"
              :key="id.item"
            >
              <div class="text-capitalize tabs-itm-txt">{{ item.name }}</div>
            </v-tab>
          </v-tabs>
          <!-- <div v-if="tradeList.length" class="b-group">
            <div class="d-flex mt-4 justify-end">
              <v-btn @click="addTrade()" class="add-trade" color="primary">
                Add Trade
              </v-btn>
            </div>
          </div> -->
          <!-- All Trade tabs items --- make seperate for each tab cause UI is borken due to reference  -->
          <v-tabs-items
            v-if="filterType != 'featured'"
            v-model="all_trades_tab"
          >
            <!-- All Trades -->
            <v-tab-item class="bg-group">
              <div
                v-if="tradeList.length"
                class="b-group mt-4 d-flex justify-space-between align-baseline"
              >
                <div
                  v-if="$vuetify.breakpoint.xsOnly"
                  :style="
                    !$vuetify.breakpoint.xsOnly ? 'visibility: hidden' : ''
                  "
                >
                  <v-btn
                    @click="openFilter.flag = true"
                    class="filter-btn"
                    right
                    outlined
                    color="#333333"
                  >
                    Filters <v-icon> mdi-chevron-down </v-icon>
                  </v-btn>
                </div>
                <div>
                  <DesktopFilters v-if="!$vuetify.breakpoint.xsOnly">
                  </DesktopFilters>
                </div>
                <div class="d-flex justify-end">
                  <!-- v-if="!$vuetify.breakpoint.xsOnly" -->
                  <v-btn
                    :small="$vuetify.breakpoint.xsOnly"
                    @click="addTrade()"
                    class="add-trade"
                    width="128px"
                    color="primary"
                  >
                    Add Trade
                  </v-btn>
                </div>
              </div>
              <!-- {{ tradeList.length }} -->
              <v-row v-if="tradeList.length" class="mt-6 mb-12 pb-10">
                <v-col
                  cols="12"
                  sm="12"
                  class="py-2"
                  v-for="(trades, id) in tradeList"
                  :key="id.trades"
                >
                  <NewTradeCard
                    v-if="status == 'ALL' && trades.is_equity_trade"
                    class="mb-4"
                    :trade_data="trades"
                    :ref="`${trades.id}`"
                  >
                  </NewTradeCard>

                  <FOTradecard
                    v-else
                    :trade_data="trades"
                    :ref="`${trades.id}`"
                    class="my-4"
                  >
                  </FOTradecard>
                </v-col>
              </v-row>
              <div
                v-else
                class="no-trades d-flex align-center flex-column justify-center"
              >
                <v-skeleton-loader width="700" type="card"></v-skeleton-loader>
                <!-- <div class="mb-4">There are no trades</div> -->
                <div v-if="group.is_admin && !$vuetify.breakpoint.xsOnly">
                  <v-btn @click="addTrade()" class="add-trade" color="primary">
                    Add Trade
                  </v-btn>
                </div>
              </div>
            </v-tab-item>
            <!-- Upcoming -->
            <v-tab-item class="bg-group">
              <div
                v-if="tradeList.length"
                class="b-group mt-4 d-flex justify-space-between align-baseline"
              >
                <div
                  v-if="$vuetify.breakpoint.xsOnly"
                  :style="
                    !$vuetify.breakpoint.xsOnly ? 'visibility: hidden' : ''
                  "
                >
                  <v-btn
                    @click="openFilter.flag = true"
                    class="filter-btn"
                    right
                    outlined
                    color="#333333"
                  >
                    Filters <v-icon> mdi-chevron-down </v-icon>
                  </v-btn>
                </div>
                <div>
                  <DesktopFilters v-if="!$vuetify.breakpoint.xsOnly">
                  </DesktopFilters>
                </div>
                <div class="d-flex justify-end">
                  <!-- v-if="!$vuetify.breakpoint.xsOnly" -->
                  <v-btn
                    :small="$vuetify.breakpoint.xsOnly"
                    @click="addTrade()"
                    class="add-trade"
                    width="128px"
                    color="primary"
                  >
                    Add Trade
                  </v-btn>
                </div>
              </div>
              <v-row v-if="tradeList.length" class="mt-6 mb-12 pb-10">
                <v-col
                  cols="12"
                  sm="12"
                  class="py-2"
                  v-for="(trades, id) in tradeList"
                  :key="id.trades"
                >
                  <NewTradeCard
                    v-if="status == 'Inactive'"
                    class="mb-4"
                    :trade_data="trades"
                    :ref="`${trades.id}`"
                  >
                  </NewTradeCard>
                </v-col>
              </v-row>
              <div
                v-else
                class="no-trades d-flex align-center flex-column justify-center"
              >
                <div class="mb-4">There are no trades</div>
                <div v-if="group.is_admin && !$vuetify.breakpoint.xsOnly">
                  <v-btn @click="addTrade()" class="add-trade" color="primary">
                    Add Trade
                  </v-btn>
                </div>
              </div>
            </v-tab-item>
            <!-- Live -->
            <v-tab-item class="bg-group">
              <div
                v-if="tradeList.length"
                class="b-group mt-4 d-flex justify-space-between align-baseline"
              >
                <div
                  v-if="$vuetify.breakpoint.xsOnly"
                  :style="
                    !$vuetify.breakpoint.xsOnly ? 'visibility: hidden' : ''
                  "
                >
                  <v-btn
                    @click="openFilter.flag = true"
                    class="filter-btn"
                    right
                    outlined
                    color="#333333"
                  >
                    Filters <v-icon> mdi-chevron-down </v-icon>
                  </v-btn>
                </div>
                <div>
                  <DesktopFilters v-if="!$vuetify.breakpoint.xsOnly">
                  </DesktopFilters>
                </div>
                <div class="d-flex justify-end">
                  <!-- v-if="!$vuetify.breakpoint.xsOnly" -->
                  <v-btn
                    :small="$vuetify.breakpoint.xsOnly"
                    @click="addTrade()"
                    width="128px"
                    class="add-trade"
                    color="primary"
                  >
                    Add Trade
                  </v-btn>
                </div>
              </div>
              <v-row v-if="tradeList.length" class="mt-6 mb-12 pb-10">
                <v-col
                  cols="12"
                  sm="12"
                  class="py-2"
                  v-for="(trades, id) in tradeList"
                  :key="id.trades"
                >
                  <NewTradeCard
                    v-if="status == 'Active'"
                    class="mb-4"
                    :trade_data="trades"
                    :ref="`${trades.id}`"
                  >
                  </NewTradeCard>
                </v-col>
              </v-row>
              <div
                v-else
                class="no-trades d-flex align-center flex-column justify-center"
              >
                <div class="mb-4">There are no trades</div>
                <div v-if="group.is_admin && !$vuetify.breakpoint.xsOnly">
                  <v-btn @click="addTrade()" class="add-trade" color="primary">
                    Add Trade
                  </v-btn>
                </div>
              </div>
            </v-tab-item>
            <!-- Closed -->
            <v-tab-item class="bg-group">
              <div
                v-if="tradeList.length"
                class="b-group mt-4 d-flex justify-space-between align-baseline"
              >
                <div
                  v-if="$vuetify.breakpoint.xsOnly"
                  :style="
                    !$vuetify.breakpoint.xsOnly ? 'visibility: hidden' : ''
                  "
                >
                  <v-btn
                    @click="openFilter.flag = true"
                    class="filter-btn"
                    right
                    outlined
                    color="#333333"
                  >
                    Filters <v-icon> mdi-chevron-down </v-icon>
                  </v-btn>
                </div>
                <div>
                  <DesktopFilters v-if="!$vuetify.breakpoint.xsOnly">
                  </DesktopFilters>
                </div>
                <div class="d-flex justify-end">
                  <!-- v-if="!$vuetify.breakpoint.xsOnly" -->
                  <v-btn
                    :small="$vuetify.breakpoint.xsOnly"
                    @click="addTrade()"
                    class="add-trade"
                    width="128px"
                    color="primary"
                  >
                    Add Trade
                  </v-btn>
                </div>
              </div>
              <v-row v-if="tradeList.length" class="mt-6 mb-12 pb-10">
                <v-col
                  cols="12"
                  sm="12"
                  class="py-2"
                  v-for="(trades, id) in tradeList"
                  :key="id.trades"
                >
                  <NewTradeCard
                    v-if="status == 'Closed'"
                    class="mb-4"
                    :trade_data="trades"
                    :ref="`${trades.id}`"
                  >
                  </NewTradeCard>
                </v-col>
              </v-row>
              <div
                v-else
                class="no-trades d-flex align-center flex-column justify-center"
              >
                <div class="mb-4">There are no trades</div>
                <div v-if="group.is_admin && !$vuetify.breakpoint.xsOnly">
                  <v-btn @click="addTrade()" class="add-trade" color="primary">
                    Add Trade
                  </v-btn>
                </div>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-tab-item>
        <!-- Watchlist tabs items -->
        <v-tab-item>
          <Watchlist
            class="px-3 mt-4"
            :group="group"
            :watchlist_data="watchlist_data"
          >
          </Watchlist>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <div
      v-if="$vuetify.breakpoint.xsOnly && group.is_admin"
      class="bottom-nav px-3"
    >
      <v-btn
        @click="addTrade()"
        block
        outlined
        height="50px"
        class="add-trade mr-5"
        color="primary"
      >
        Add Trade
      </v-btn>
    </div>
    <FilterTab :openFilters="openFilter"> </FilterTab>
  </div>
</template>

<script>
// import newAxios from "@/api/newAxios";
import { mapActions } from "vuex";
import Axios from "@/api/BaseAxios.js";
import commonFunctions from "@/common/commonFunctions";
import FOTradecard from "@/components/F&OTradecards.vue";
import FilterTab from "@/components/Group/PremiumGroups/filters.vue";
import DesktopFilters from "@/components/Group/PremiumGroups/DesktopFilters.vue";
import Watchlist from "./Watchlist.vue";
import apiUrl from "@/common/apiUrl";
export default {
  name: "GroupTabs",
  props: {
    group: {
      type: Object,
      required: true,
    },
    watchlist_data: {
      type: Array,
      required: true,
    },
  },
  components: {
    NewTradeCard: () => import("@/components/TradeCard.vue"),
    FOTradecard,
    FilterTab,
    DesktopFilters,
    Watchlist,
  },
  data() {
    return {
      subscription: 0,
      commonFun: commonFunctions,
      isAuth: commonFunctions,
      tradeList: [],
      featureTradeList: [],
      loading: false,
      tab: 0,
      all_trades_tab: null,
      tab_items: ["Featured Trades", "All Trades"],
      allTrades_item: ["All Trades"],
      favourite: require("@/assets/images/favourite.svg"),
      lock: require("@/assets/images/lock.png"),
      openFilter: {
        flag: false,
      },
      // all_trade_tabs_item: ["All", "Upcoming", "Live", "Closed"],
      all_trade_tabs_item: [
        { name: "All", status: "ALL" },
        { name: "Upcoming", status: "Inactive" },
        { name: "Live", status: "Active" },
        { name: "Closed", status: "Closed" },
      ],
      page_info: {
        page_number: 1,
        detail_count: 18,
        total_page: 1,
      },

      filters: {},
    };
  },
  computed: {
    is_same_user() {
      const user_id = localStorage.getItem("user_id");
      return Number(user_id) === Number(this.user_id);
    },
    filteredTabItems() {
      return this.tab_items.filter((item) => item !== "Featured Trades");
    },
    // all_trades() {
    //   return this.tab_items[this.tab] == "Featured Trades" &&
    //     this.tradeList.length
    //     ? this.tab_items
    //     : this.allTrades_item;
    // },
    filterType() {
      return this.tab_items[this.tab] == "Featured Trades"
        ? "featured"
        : "paper";
    },
    status: {
      get() {
        return this.all_trade_tabs_item[this.all_trades_tab].status;
      },
      set(value) {
        return value;
      },
    },
    detail() {
      let detail = {};
      detail["group_id"] = this.group.id;
      detail["plan"] = this.group.price[this.subscription].id;
      detail["user_id"] = this.commonFun.getUserId();
      return detail;
    },
  },
  watch: {
    all_trades_tab() {
      this.tradeList = [];
      this.getTrades();
    },
    tab() {
      this.tradeList = [];
      this.featureTradeList = [];
      this.getTrades();

      if (
        this.tab_items[this.tab] == "Featured Trades" &&
        this.featureTradeList.length == 0 &&
        !this.group.is_admin &&
        !this.$vuetify.breakpoint.xsOnly
      ) {
        console.log("inside tabsd");
        // this.tab_items = this.tab_items.slice(1, 1);
        this.tab_items = ["All Trades"];
        console.log(this.tab_items);
      } else if (this.featureTradeList.length != 0) {
        this.tab_items.unshift("Featured Trades");
      }
    },
  },
  methods: {
    ...mapActions({
      toggleTradeModal: "tradeData/toggleModal",
      toggleAddTradeModal: "addTrade/toggleTradeModal",
    }),
    addTrade() {
      this.$logEvent("add_trade_group_detail_page");
      if (this.$vuetify.breakpoint.xsOnly) {
        this.$logEvent("mweb_add_trade_group_detail_page");
      }
      // this.toggleTradeModal({ show: true, type: "add", groupId: this.groupId });
      this.toggleAddTradeModal({
        show: true,
        type: "add",
        groupId: String(this.group.id),
      });
    },

    async getTrades() {
      this.loading = true;
      const successHandler = (res) => {
        // console.log(res);
        this.page_info = res.data.page_info;

        // const data = {
        //   type: "security",
        //   id: this.security_ids,
        // };
        // this.socket.send(JSON.stringify(data));
        // console.log(res, "res");
        // console.log(data, "get data");
        this.tradeList = res.data.results;
        if (this.filterType == "featured") {
          this.featureTradeList = res.data.results;
        }
        // setTimeout(() => {
        //   this.loading = false;
        // }, 500);
      };
      const failureHandler = () => {
        this.loading = false;
      };
      let formData = {};
      formData["group_id"] = this.group.id;
      formData["filter_by"] = this.filterType;
      // formData["filter_type"] = this.filterType;

      if (this.filterType != "featured") {
        formData["res_type"] = "others";
      }
      if (this.filterType == "featured") {
        formData["trade_status"] = "ALL";
      } else {
        formData["trade_status"] = this.status;
      }

      formData["page_number"] = this.page_info.page_number;
      formData["detail_count"] = this.page_info.detail_count;

      if (this.is_same_user) {
        formData["is_same_user"] = this.is_same_user;
      }
      if (this.group.is_admin) {
        formData["is_admin"] = this.group.is_admin;
      }
      if (Object.keys(this.filters).length !== 0) {
        formData["filters"] = this.filters;
      }
      Axios.request_GET(
        "api/trade/trade-list-view/",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    create_payment_order() {
      this.loading = true;
      const successHandler = (res) => {
        console.log(res);
        this.duration = res.data.duration_detail;
        this.order_detail = res.data.order_detail;
        this.admin_id = this.order_detail.group_detail.admin.id;
        // console.log(this.admin_id);
        this.key_id = res.data.key_id;
        this.prefill = res.data.prefill;
        // this.loadImageComponent = true;
        this.loading = false;
        this.openPaymentGateway();
      };
      const failureHandler = () => {
        this.loading = false;
      };
      let formData = {};
      formData["group_id"] = this.group.id;
      formData["plan"] = this.group.price[this.subscription].id;
      formData["user_id"] = this.commonFun.getUserId();
      if (this.couponAppliedFlag == true) {
        formData["coupon"] = this.couponCode;
      }
      Axios.request_POST_PARAMS(
        apiUrl.ORDER_PAYMENT,
        {},
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    openPaymentGateway() {
      const self = this;
      this.payBtnLoader = true;
      let total_price = this.order_detail.total_price * 100;
      let options = {
        key: this.key_id, // Enter the Key ID generated from the Dashboard
        amount: total_price, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
        currency: "INR",
        name: this.order_detail.group_detail.name,
        description: "Paid Membership",
        image: this.order_detail.group_detail.picture,
        order_id: this.order_detail.order_id,
        handler: function (response) {
          self.updatePaymentDetail(true, response);
          self.paymentSuccess = true;
          // this.$logEvent("premium_group");
          if (this.$vuetify.breakpoint.xsOnly) {
            this.$logEvent("mweb_premium_group");
          }
          if (this.admin_id == 99779) {
            this.$logEvent("covesting_technologies_group");

            if (this.$vuetify.breakpoint.xsOnly) {
              this.$logEvent("mweb_covesting_technologies_group");
            }
          }

          // alert(response.razorpay_payment_id);
          // alert(response.razorpay_order_id);
          // alert(response.razorpay_signature);
        },
        // callback_url: "http://localhost:8000/api/payment-webhook/",
        // prefill: {
        //   name: "Gaurav Kumar",
        //   email: "gaurav.kumar@example.com",
        //   contact: "9999999999",
        // },
        prefill: this.prefill,
        // notes: {
        //   address: "Razorpay Corporate Office",
        // },
        theme: {
          color: "#3399cc",
        },
      };
      var rzp1 = window.Razorpay(options);
      rzp1.on("payment.failed", function (response) {
        this.payBtnLoader = false;
        rzp1.close();
        this.$logEvent("premium_group_failed");
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$logEvent("mweb_premium_group_failed");
        }
        if (this.admin_id == 99779) {
          this.$logEvent("covesting_technologies_group_failed");

          if (this.$vuetify.breakpoint.xsOnly) {
            this.$logEvent("mweb_covesting_technologies_group_failed");
          }
        }

        // alert(response.error.code);
        // alert(response.error.description);
        // alert(response.error.source);
        // alert(response.error.step);
        // alert(response.error.reason);
        // alert(response.error.metadata.order_id);
        // alert(response.error.metadata.payment_id);
        self.snackBar({
          text: `failed : ${response.error.reason}, Payment ID: ${response.error.metadata.payment_id}`,
          color: "error",
          timeout: 2500,
        });
        self.updatePaymentDetail(false, response);
        // self.togglePaymentDetail({ show: false });
      });
      rzp1.open();
    },
    updatePaymentDetail(success, res) {
      const successHandler = () => {
        // this.count++;
        // if (this.count == 1) {
        this.$logEvent("premium_group");
        // }
        // if (this.$vuetify.breakpoint.xsOnly) {
        //   this.$logEvent("mweb_premium_group");
        // }
        // console.log(this.admin_id);
        if (this.admin_id == 99779) {
          this.$logEvent("covesting_technologies_group");
          console.log("successfully enter in to covesting technologies group");
          if (this.$vuetify.breakpoint.xsOnly) {
            this.$logEvent("mweb_covesting_technologies_group");
          }
        }
        this.eventBus.$emit("refresh-group-detail");

        this.payBtnLoader = false;
      };
      const failureHandler = () => {
        this.payBtnLoader = false;
      };
      const finallyHandler = () => {
        if (success) {
          this.eventBus.$emit("refresh-group-detail");
        }
      };
      let formData = {};
      formData["id"] = this.order_detail.id;
      if (success) {
        formData["payment_id"] = res.razorpay_payment_id;
        formData["payment_signature"] = res.razorpay_signature;
        formData["payment_status"] = "successful";
        // const url = `${location.protocol}//${location.host}/groups/2145`;
        // window.open(url, "_self");
      } else {
        this.payBtnLoader = false;
        formData["payment_status"] = "failed";
      }
      Axios.request_PATCH(
        apiUrl.ORDER_PAYMENT,
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true,
        finallyHandler
      );
    },
    formatTradeDate(dateString) {
      const date = new Date(dateString);

      const timeOptions = { hour: "2-digit", minute: "2-digit", hour12: true };
      const dateOptions = { day: "2-digit", month: "long" };

      const time = date.toLocaleTimeString("en-US", timeOptions);
      const day = date.toLocaleDateString("en-US", dateOptions);

      return `${time} ${day}`;
    },
  },
  created() {
    this.eventBus.$on("filters", (value) => {
      this.filters = value;
      this.getTrades();
    });
  },
  beforeDestroy() {
    this.eventBus.$off("filters");
  },
  mounted() {
    this.getTrades();
    // console.log(this.tab);
    if (
      this.tab_items[this.tab] == "Featured Trades" &&
      this.featureTradeList.length == 0 &&
      !this.group.is_admin &&
      !this.$vuetify.breakpoint.xsOnly
    ) {
      this.tab_items = ["All Trades"];
      console.log("inside tabsd");

      // console.log(this.tab_items);
      // console.log(this.featureTradeList.length);
    } else if (this.featureTradeList.length != 0) {
      console.log("add ");
      this.tab_items.unshift("Featured Trades");
    }
    if (
      this.filterType == "featured" &&
      this.featureTradeList.length == 0 &&
      this.$vuetify.breakpoint.xsOnly &&
      !this.group.is_admin
    ) {
      this.tab_items.splice(0, 1);
      // console.log(this.tab_items);
    }
    // if (this.tab == 0) {
    //   this.tab = "Sagar";
    // } else {
    //   this.tab = "pawan";
    // }
    // this.getTrades();
    // Vue.prototype.$on("groupDetailsFetched", this.getTrades());
  },
};
</script>

<style lang="scss" scoped>
.banking_div {
  border: 1px solid #e4e4e4;
  border-radius: 12px;
  width: 450px;
}

.equal-widths > div {
  flex: 1;
  min-width: 0;
}

.equal-widths .text-center {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.position-relative {
  position: relative;
  z-index: 4;
}

/*.blurred {
  filter: blur(4px);
  pointer-events: none;
}*/

.overlay-card {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(4px);
  background: rgba(255, 255, 255, 0.8);
  z-index: 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.overlay-card .v-card-text,
.overlay-card .v-card-actions {
  pointer-events: all;
}

@media only screen and (max-width: 768px) {
  .main-label {
    font-family: Avenir;
    font-size: 17px !important;
    font-weight: 800;
    line-height: 19.12px !important;
    text-align: left;
  }

  .mytab {
    // height: 30px !important;
    padding: 5px !important;
    border-radius: 8px;
  }

  .tabs-txt {
    font-family: Avenir;
    font-size: 14px !important;
    font-weight: 900;
    line-height: 13.66px;
    text-align: center;
  }

  .tabs-itm-txt {
    font-family: Avenir;
    font-size: 12px !important;
    font-weight: 500;
    line-height: 14px !important;
    text-align: left;
  }

  .gif-img {
    height: 48px !important;
    width: 48px !important;
  }

  .feature-txt {
    font-family: Avenir;
    font-size: 18px !important;
    font-weight: 800;
    line-height: 24.59px !important;
    text-align: center;
  }

  .feature-sub-txt {
    font-family: Avenir;
    font-size: 11px !important;
    font-weight: 500;
    line-height: 15.03px !important;
    text-align: center;
  }

  .no-trades {
    height: 27vh !important;
  }

  // ::v-deep.v-tabs
  //   > .bg-group
  //   > div
  //   > .theme--light.v-tabs
  //   > .v-tabs-bar
  //   > .v-slide-group__prev
  //   v-slide-group__prev--disabled {
  //   display: none !important;
  // }
  // .v-slide-group__prev.v-slide-group__prev--disabled {
  //   display: none !important;
  // }

  // ::v-deep.v-slide-group.v-item-group > .v-slide-group__prev {
  //   display: none !important;
  // }
  .add-trade {
    width: 100px !important;
    font-family: Avenir;
    font-size: 14px !important;
    font-weight: 400;
    line-height: 21.86px;
    text-align: center;

    // height: 32px !important;
  }

  .filter-btn {
    width: 85px;
    background-color: #fff;
    border-radius: 4px;
    text-transform: capitalize;
    height: 32px;
    border-color: #e4e4e4;
  }
}

::v-deep.v-tabs:not(.v-tabs--vertical):not(.v-tabs--right)
  > .v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes)
  .v-slide-group__prev {
  /* display: initial; */
  display: none !important;
}

.add-trade {
  width: 168px;
  height: 40px;
  border-radius: 4px;
  text-transform: capitalize;
}

.tooltip {
  background: #f7faff;
  opacity: 1 !important;
  // text-align: center;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px !important;
}

.tooltip-text {
  color: #111111 !important;
}

.mytab {
  height: 52px;
  padding: 10px;
  border-radius: 8px;
}

.bg-group {
  background-color: #fafafa;
}

.tab-color {
  background-color: #d5e8ff;
}

.single-tab {
  background-color: #fff;
}

.main-label {
  font-family: Avenir;
  font-size: 20px;
  font-weight: 800;
  line-height: 27.32px;
  text-align: left;
  color: #333333;
}

.includes-trades {
  font-family: Avenir;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: 19.12px;
  text-align: left;
  color: #333333ad;
}

.feature-txt {
  font-family: Avenir;
  font-size: 24px;
  font-weight: 800;
  line-height: 32.78px;
  text-align: center;
  color: #333333;
}

.feature-sub-txt {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 500;
  line-height: 21.86px;
  text-align: center;
  color: #333333b8;
}

.gif-img {
  margin-left: auto;
  margin-right: auto;
}

.no-trades {
  height: 50vh;
  font-family: Avenir;
  font-size: 16px;
  font-weight: 800;
  line-height: 21.86px;
  text-align: center;
  color: #333333b8;
}

.no-feature-trades {
  height: 50vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.bottom-nav {
  height: 88px;
  display: flex;
  // justify-content: center;
  align-items: center;
  width: 100%;
  position: fixed;
  bottom: 0;
  top: auto;
  background-color: #fff;
  z-index: 20;
}
</style>
